
/* styles */
require("!!./../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!./../../node_modules/vue-loader/lib/style-rewriter?{\"id\":\"data-v-73756cb6\",\"scoped\":true,\"hasInlineConfig\":true}!./../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ListBeers.vue")

var Component = require("!./../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../node_modules/vue-loader/lib/selector?type=script&index=0!./ListBeers.vue"),
  /* template */
  require("!!./../../node_modules/vue-loader/lib/template-compiler?{\"id\":\"data-v-73756cb6\"}!./../../node_modules/vue-loader/lib/selector?type=template&index=0!./ListBeers.vue"),
  /* scopeId */
  "data-v-73756cb6",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ListBeers.vue
// module id = 22
// module chunks = 0